/**
 * Label of the Executive Session flow. It reuses the Relational Systems LimeSurvey
 * template, so the two entries below point at the same template id — the distinction
 * lives only in the `surveyType` stored on the survey's DynamoDB row.
 */
export const EXECUTIVE_SESSION_LABEL = 'Executive Session';

/** Value stored as `surveyType` on the backend; must match EXECUTIVE_SESSION in the Lambda types. */
export const EXECUTIVE_SESSION_TYPE = 'executive_session';

export const SURVEY_MAPPING: { [key: string]: string } = {
  'Relational Systems': '292197',
  [EXECUTIVE_SESSION_LABEL]: '292197',
  Assessment: '451786',
  Playbook: '658765',
  'Sync Point': '164542',
};

/** Number of date slots on a cohort. Changing this value propagates to Excel headers, DynamoDB fields, and the UI. */
export const COHORT_DATE_COUNT = 6;
